import React from 'react';
import { FontIcon } from '@topconagriculture/react-components';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
const useStyles = makeStyles(() => ({
    weatherLocationErrorContainer: {
        display: 'flex',
        margin: 'auto',
        overflow: 'hidden',
        justifyContent: 'center',
    },
    weatherLocationError: {
        borderRadius: 5,
        padding: 5,
        backgroundColor: '#eceff1',
        maxWidth: '95%',
    },
    warningIcon: { color: 'orange', padding: 5, verticalAlign: 'middle' },
    icon: {
        display: 'inline',
    },
    errorText: {
        display: 'inline-block',
        verticalAlign: 'middle',
        width: '75%',
    },
}));
export const WeatherError = () => {
    const classes = useStyles();
    const { t } = useTranslation();
    return (React.createElement("div", { className: classes.weatherLocationErrorContainer },
        React.createElement("div", { className: classes.weatherLocationError },
            React.createElement("div", { className: classes.icon },
                React.createElement(FontIcon, { iconName: "warning", size: 40, className: classes.warningIcon })),
            React.createElement("div", { className: classes.errorText }, t('widget:widget:location_settings_error')))));
};
//# sourceMappingURL=WeatherError.js.map